import { Component, OnInit } from '@angular/core';
import { PagosService, ReportesService, OptionsService, PaymentDetailsService, PAYMENT_DETAIL_CONFIG, InvoicePD } from '../../services/service.index';
import { Router } from '@angular/router';
import { AltaSolicitudesService } from '../../services/altasolicitudes/altasolicitudes.service';
import swal2 from 'sweetalert2';
// [13/08/2026] Se retiró Bugsnag: el dashboard no se revisaba hace ~1 año.

@Component({
  selector: 'app-decadena',
  templateUrl: './decadena.component.html',
  styles: []
})
export class DeCadenaComponent implements OnInit {

  cols: any[] = [];
  fecha: string;
  cadenas: any[] = [];
  cadenaso: any[] = [];
  cadenasw: any[] = [];
  cadenasow: any[] = [];
  correo: string = '';
  facturas: any[] = [];
  selectedFac: any[] = [];
  idp: string = '';
  idcontribuyente: string = '';
  idcontfinan: string = '';
  totalFac: number = 0;
  totalFacs: string = '0';
  totalFacsFormateado: string = '0';
  cdirecta: string = 'true';
  valorcdirecta: string = 'true';
  currency: any[] = [];
  paymentTypes: any[] = [];
  fill: boolean = true;
  nomname: string = '';
  bancos: any[] = [];
  showBanks: boolean = false;
  selectedBank: string = '';
  banks: any[] = [];
  hayBancos = false;
  npago = '';
  // [01/10/2026] Flag de ajustes detalles: controla si se usa el endpoint PD o el legacy
  usarAjustesDetalles: boolean = false;
  constructor(
    public router: Router,
    public _optionsservice: OptionsService,
    public _reportesservice: ReportesService,
    public _pagosservice: PagosService,
    private _solicitudesservice: AltaSolicitudesService,
    // [01/10/2026] Servicio de ajustes detalles (Payment Details)
    private _paymentDetailsService: PaymentDetailsService
  ) {}

  ngOnInit() {
    swal2.showLoading();
    var a = new Date();
    a.setMinutes(a.getMinutes() + a.getTimezoneOffset());
    var montha = '' + (a.getMonth() + 1);
    var daya = '' + a.getDate();
    var yeara = a.getFullYear();
    if (montha.length < 2) { montha = '0' + montha; }
    if (daya.length < 2) { daya = '0' + daya; }
    this.fecha = [yeara, montha, daya].join('-');

    this.cols = [
      { field: 'folio_reporte', header: 'Folio Reporte' },
      { field: 'folio_factura', header: 'Folio Factura' },
      { field: 'uuid', header: 'UUID' },
      { field: 'monto_total', header: 'Monto Total' },
      { field: 'porcentaje_operado', header: 'Porcentaje Operado' },
      { field: 'emisor', header: 'Emisor' },
      { field: 'receptor', header: 'Receptor' },
      { field: 'moneda', header: 'Moneda' },
      { field: 'fecha_operacion', header: 'Fecha de operación' },
      { field: 'fecha_vencimiento', header: 'Fecha de vencimiento' },
      { field: 'fecha_emision', header: 'Fecha de emision' },
      { field: 'fecha_carga', header: 'Fecha de carga' },
      { field: 'estatus', header: 'Estatus' }
    ];

    this._pagosservice.getCadenas().subscribe(resp => {
      this.cadenas = resp;
      swal2.close();
    });

    this._solicitudesservice.getGeneralParam('NOMBRE_FINANCIERA').subscribe(resp => {
      this.nomname = resp['value'];
    });

    this._solicitudesservice.getPaymentCurrency().subscribe(resp => { this.currency = resp; });
    this._solicitudesservice.getPaymentTypes().subscribe(resp => { this.paymentTypes = resp; });

    this._pagosservice.getAcountigAcountBanks().subscribe(resp => {
      this.banks = resp;
      this.hayBancos = resp && resp.length > 0;
    });
    // [01/10/2026] Consultar flag de ajustes detalles para cobranza de cadena
    this._paymentDetailsService.checkFlag(PAYMENT_DETAIL_CONFIG.COBRANZA_CADENA.flag).subscribe(activo => {
      this.usarAjustesDetalles = activo;
      // [05/10/2026] Columnas PD: 12 columnas base según imagen + 3 extra de moratorios
      if (activo) {
        this.cols = [
          { field: 'folio_reporte', header: 'Folio Reporte' },
          { field: 'folio_factura', header: 'Folio Factura' },
          { field: 'uuid', header: 'UUID' },
          { field: 'total_a_pagar', header: 'Total a Pagar' },
          { field: 'emisor', header: 'Emisor' },
          { field: 'receptor', header: 'Receptor' },
          { field: 'moneda', header: 'Moneda' },
          { field: 'fecha_operacion', header: 'Fecha Operación' },
          { field: 'fecha_vencimiento', header: 'Fecha Vencimiento' },
          { field: 'fecha_emision', header: 'Fecha Emisión' },
          { field: 'fecha_carga', header: 'Fecha Carga' },
          { field: 'estatus', header: 'Estatus' },
          { field: 'moratorios_fmt', header: 'Moratorios' },
          { field: 'dias_vencidos', header: 'Dias Vencidos' },
          { field: 'saldo_pendiente_fmt', header: 'Saldo Pendiente' }
        ];
      }
    });
  }

  seleccioncobranzadd() {
    this.valorcdirecta = (document.querySelector('input[name="screcurso"]:checked') as HTMLInputElement).value;
    this.cdirecta = this.valorcdirecta;
    this.cadenas = [];
    this.cadenasw = [];
    this.facturas = [];
    this.selectedFac = [];
    this.idp = '';
    this.npago = '';
    this.selectedBank = '';
    this.totalFacsFormateado = '0';
    (document.getElementById('correo') as HTMLInputElement).value = '';
    (document.getElementById('notas') as HTMLInputElement).value= '';
    (document.getElementById('voucher') as HTMLInputElement).value = '';
    swal2.showLoading();
    if (this.cdirecta === 'true') {
      this._pagosservice.getCadenas().subscribe(resp => {
        this.cadenas = resp;
        swal2.close();
      });
    } else {
      this._pagosservice.getCadenasw().subscribe(resp => {
        this.cadenasw = resp;
        swal2.close();
      });
    }
  }

  getcorreo() {
    this.facturas = [];
    this.selectedFac = [];
    this.totalFacsFormateado = '0';
    if (this.cdirecta === 'true') {
      var select: any = document.getElementById('cadena');
      var value = select.options[select.selectedIndex].value;
      for (var i in this.cadenas) {
        if (this.cadenas[i].id_cadena == value) {
          this.idp = this.cadenas[i].id_cadena;
          this.correo = this.cadenas[i].email_contribuyente;
          this.idcontribuyente = this.cadenas[i].id_contribuyente;
          this.idcontfinan = this.cadenas[i].id_cont_finan;
        }
      }
    } else {
      var selectw: any = document.getElementById('cadenaw');
      var valuew = selectw.options[selectw.selectedIndex].value;
      for (var j in this.cadenasw) {
        if (this.cadenasw[j].id_proveedor == valuew) {
          this.idp = this.cadenasw[j].id_proveedor;
          this.correo = this.cadenasw[j].email_contribuyente;
          this.idcontribuyente = this.cadenasw[j].id_contribuyente;
          this.idcontfinan = this.cadenasw[j].id_cont_finan;
        }
      }
    }
  }

  muestraFacturas() {
    var moneda: any = document.getElementById('moneda');
    var valormoneda = moneda.options[moneda.selectedIndex].value;

    if (this.showBanks && !this.selectedBank) {
      swal2.fire('Debe seleccionar un banco', '', 'error');
      return;
    }

    swal2.fire({ title: 'Cargando', allowOutsideClick: false });
    swal2.showLoading();

    if (this.idp === '' && this.cdirecta === 'true') {
      swal2.fire('Debe seleccionar una empresa', '', 'error');
      return;
    }
    if (this.idp === '' && this.cdirecta === 'false') {
      swal2.fire('Debe seleccionar un proveedor', '', 'error');
      return;
    }

    // [01/10/2026] Bifurcación: si ajustes detalles está activo, consultar endpoint PD
    if (this.usarAjustesDetalles) {
      this._paymentDetailsService.getInvoicesPD(
        Number(this.idcontribuyente), Number(this.idcontfinan),
        PAYMENT_DETAIL_CONFIG.COBRANZA_CADENA.tipoRegistroPago,
        this.fecha
      ).subscribe(resp => {
        swal2.close();
        this.facturas = this.mapearFacturasPD(resp);
        this.fill = false;
        if (!this.facturas || this.facturas.length === 0) {
          swal2.fire('No se encontraron Datos', '', 'error');
        }
      }, (err) => {
        swal2.close();
        console.log(err);
        // [01/10/2026] Diferenciar errores 422: flag inactivo → fallback a legacy
        if (this._paymentDetailsService.esFlagInactivo(err)) {
          this.usarAjustesDetalles = false;
          this.muestraFacturas();
          return;
        }
        const titulo = (err && err.status === 422)
          ? 'Error de configuración en ajustes detalles'
          : 'Ocurrió un error al consultar ajustes detalles';
        swal2.fire({
          title: titulo,
          text: '',
          icon: 'error',
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: false
        }).then(() => this.ngOnInit());
      });
      return;
    }

    var call$ = this.cdirecta === 'true'
      ? this._pagosservice.getFacturasPagoCadena(this.idp, valormoneda)
      : this._pagosservice.getFacturasPagoCadenaw(this.idp, valormoneda);

    call$.subscribe(resp => {
      swal2.close();
      this.facturas = resp;
      this.fill = false;
      if (!resp || resp.length === 0) {
        swal2.fire('No se encontraron Datos', '', 'error');
      }
    }, function (err) {
      swal2.close();
      console.log(err);
      swal2.fire(
        'Ocurrió un error',
        (err.error && err.error.errors && err.error.errors[0]) ? err.error.errors[0] : '',
        'error'
      ).then(() => this.ngOnInit());
    }.bind(this));
  }

  getTotal() {
    var tp = 0;
    for (var i in this.selectedFac) {
      tp += parseFloat(this.selectedFac[i].monto_total.replace(/,/g, ''));
    }
    this.totalFacs = tp.toFixed(2);
    this.totalFacsFormateado = tp.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  filtro(e: any) {
    var moneda: any = document.getElementById('moneda');
    var valormoneda = moneda.options[moneda.selectedIndex].value;

    var call$ = null;
    if (e === 'NO DESCONTADA') {
      call$ = this._reportesservice.getPaymentsNoDescontada(valormoneda, this.idp);
    } else if (e === 'DESCONTADAS SIN FONDEO') {
      call$ = this._reportesservice.getPaymentsDescontadaSinFondeo(valormoneda, this.idp);
    } else if (e === 'DESCONTADAS CON FONDEO') {
      call$ = this._reportesservice.getPaymentsDescontadaConFondeo(valormoneda, this.idp);
    }

    if (call$) {
      call$.subscribe(r => { this.facturas = r; });
    }
  }

  /**
   * [05/10/2026] Mapea facturas del endpoint PD al formato de tabla con 12 columnas base + moratorios.
   * Se mantiene monto_total mapeado desde total_a_pagar para compatibilidad con getTotal().
   */
  mapearFacturasPD(facturas: InvoicePD[]): any[] {
    return facturas
      .filter(f => f.payment_status !== 'PAGADO')
      .map(f => ({
        id_factura: f.invoice_id,
        folio_reporte: f.folio_reporte,
        folio_factura: f.folio_factura,
        uuid: f.uuid,
        total_a_pagar: this._paymentDetailsService.formatearMonto(f.total_a_pagar),
        emisor: f.emisor,
        receptor: f.receptor,
        moneda: f.moneda,
        fecha_operacion: f.fecha_operacion,
        fecha_vencimiento: f.fecha_vencimiento,
        fecha_emision: f.fecha_emision,
        fecha_carga: f.fecha_carga,
        estatus: f.estatus_factura,
        // [05/10/2026] Columnas extra de moratorios
        moratorios_fmt: this._paymentDetailsService.formatearMonto(f.moratorios),
        dias_vencidos: f.dias_vencidos,
        saldo_pendiente_fmt: this._paymentDetailsService.formatearMonto(f.saldo_pendiente),
        // [05/10/2026] monto_total se mantiene para compatibilidad con getTotal()
        monto_total: this._paymentDetailsService.formatearMonto(f.total_a_pagar),
        es_parcial: f.payment_status === 'PARCIAL',
        tiene_moratorios: f.moratorios > 0
      }));
  }

  guardar() {

    if (this.selectedFac.length === 0) {

      swal2.fire(
        'Debe seleccionar al menos una Factura',
        '',
        'error'
      );

    } else {

      const tpago: any = document.getElementById('tdpago');
      const moneda: any = document.getElementById('moneda');

      const valortpago = tpago.options[tpago.selectedIndex].value;
      const valormoneda = moneda.options[moneda.selectedIndex].value;
      let payment_number = (document.getElementById('npago') as HTMLInputElement).value;
      const payment: any = {
        payment_date: (document.getElementById('fecha') as HTMLInputElement).value,
        payment_number: payment_number,
        payment_type: valortpago,
        currency: valormoneda,
        amount: this.totalFacs,
        email_cfdi: (document.getElementById('correo') as HTMLInputElement).value,
        notes: (document.getElementById('notas') as HTMLInputElement).value,
        voucher: (document.getElementById('voucher') as HTMLInputElement).value,
        contributor_from_id: this.idcontribuyente,
        contributor_to_id: this.idcontfinan
      };
      if (this.hayBancos && this.selectedBank) {
        payment.bank = this.selectedBank; 
      }
      const params = {
        payment_source: 'CADENA',
        invoices: [],
        payment: payment
      }; 
      // tslint:disable-next-line: forin
      for (const prop in this.selectedFac) {
        params.invoices[prop] = {id: this.selectedFac[prop].id_factura.toString() };
      }
      swal2.fire({
        title: 'Cargando',
        allowOutsideClick: false
   });
      swal2.showLoading();
      this._pagosservice.aplicarPagoRAWproveedor(params).subscribe( resp => {
        // swal2.close();
        swal2.fire({
          title: 'La información se registró',
          text: 'con éxito',
          icon: 'success',
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: false
        }). then ( res => {

          if ( res.value ) {
            this._pagosservice.notificacionPagoFacturas({id: resp['data'].id}).subscribe(() => {
              window.location.reload();

            }, err => {
              console.log(err);
              try{
                swal2.fire('Atención', err.error.error, 'info');
              }
              catch{
                swal2.fire('Atención', 'Algo salió mal al enviar notificación', 'info');
              }
            });
          }

        } );

      }, (err) => {
        swal2.close();
        console.log(err);
        swal2.fire({
          title: 'Ocurrio un error',
          text: err.error.errors[0],
          icon: 'error',
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: false
        }). then ( res => {
          if ( res.value ) {
            this.ngOnInit();
          }
        } );
       } );

    }


  }

}








